import type { Models } from '~/services-v2/financial-bff/financial-bff'

import { useMutation } from '@tanstack/vue-query'
import financialBff from '~/services-v2/financial-bff/financial-bff'

export type ProjectCreateParams = Models['ProjectCreateInput']

export default function useProjectCreate() {
  const mutationKey = ['project', 'create']

  const mutationFn = async (input: ProjectCreateParams) => {
    const res = await financialBff('mutation')({
      project_create: [
        {
          input,
        },
        {
          id: true,
          status: true,
        },
      ],
    })

    return res.project_create
  }

  return useMutation({
    mutationKey,
    mutationFn,
    retry: (failureCount, error: any | any[]) => {
      if (error.message === 'INVALID_POWER') {
        return false
      }

      return failureCount < 3
    },
    retryDelay: 1000,
  })
}
